var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcInfo = function SvgIcInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "istytucja",
    transform: "translate(-69.000000, -635.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CTA",
    transform: "translate(41.000000, 622.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button_icon",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49727273,4.88245144 C7.73727273,4.88245144 7.92272727,4.81725832 8.05363636,4.68687207 C8.18454545,4.55648582 8.25,4.39305649 8.25,4.19658406 C8.25,3.99653941 8.18454545,3.8304309 8.05363636,3.69825854 C7.92272727,3.56608618 7.73727273,3.5 7.49727273,3.5 C7.25727273,3.5 7.07272727,3.56608618 6.94363636,3.69825854 C6.81454545,3.8304309 6.75,3.99653941 6.75,4.19658406 C6.75,4.39305649 6.81454545,4.55648582 6.94363636,4.68687207 C7.07272727,4.81725832 7.25727273,4.88245144 7.49727273,4.88245144 Z M8.15727273,11.5 L8.15727273,5.70227729 L6.83181818,5.70227729 L6.83181818,11.5 L8.15727273,11.5 Z",
    id: "ic_info",
    fill: "#12100B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#12100B",
    strokeWidth: 1.5,
    cx: 7.5,
    cy: 7.5,
    r: 6.75
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_info.dd90cd39.svg";
export { ForwardRef as ReactComponent };